import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {makeRequest, getErrorCode, displayMessage} from  'actions';
import {Col, Row, Modal, Button} from 'react-bootstrap';

import moment from 'moment'

class SubscriptionManagement extends Component {
    static get contextTypes() {
        return {
            router: React.PropTypes.object.isRequired,
        };
    }

    constructor(props, context) {
        super(props, context);

        this.state = {
            clientMessageModalVisible: false,
            clientMessage: '',
        }
    }

    componentWillMount() {
        var self = this;
        if (_.includes(this.props.location.pathname, '/unsubscribe-notification') && this.props.params.token) {
            var methodData = {
                'endpoint': '/unsubscribe-notifications',
                'type': 'post',
                'not_display_success_message': true,
            };
            this.props.makeRequest({unsubscribeToken:   this.props.params.token }, methodData).then(res => {
                console.log('res unsubscribe-from-notifications', res);
                self.setState({
                    clientMessageModalVisible: true,
                    clientMessage: res.data.clientMessage,
                });
            }).catch(error => {
            });
        } else if (_.includes(this.props.location.pathname, '/unsubscribe/') && this.props.params.id) {
            var methodData = {
                'endpoint': '/unsubscribe/' +  encodeURIComponent(this.props.params.id),
                'type': 'patch',
                'not_display_success_message': true,
            };
            this.props.makeRequest({Deleted: true }, methodData).then(res => {
                console.log('res products', res);
                self.setState({
                    clientMessageModalVisible: true,
                    clientMessage: res.data.clientMessage,
                });
            }).catch(error => {
            });
        }
    }

    render() {
        console.log('utcOffset', moment().utcOffset());
         return (
            <div className="subscription-management">
                {this.state.clientMessageModalVisible &&
                <Modal
                    show={true}
                    onHide={(e) => this.setState({clientMessageModalVisible: false})}
                >
                    <Modal.Header closeButton>
                    </Modal.Header>
                    <Modal.Body  className="center-vertically"  style={{minHeight:'200'}}>
                        <div style={{fontSize:22, paddingBottom:20}}>{this.state.clientMessage}</div>
                    </Modal.Body>

                </Modal>
                }
            </div>
        );
    }
}

function mapStateToProps(state, props) {
    return {};
}
function mapDispatchToProps(dispatch) {
    return bindActionCreators({makeRequest}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(SubscriptionManagement);

